export default __webpack_public_path__ + "static/16_30-72ac54f0c37b29233bc6523bff45fa80.png";